/** These API calls return JSON, except explicit HTTP 204 acknowledgements. */
export async function readApiResponse<T>(response: Response): Promise<T> {
  if (response.status === 204) return { success: true } as T;
  if (!response.headers.get('content-type')?.includes('application/json')) {
    throw new Error('Unexpected response format from server');
  }
  try {
    const data = await response.json();
    if (data === null || data === undefined) throw new Error('Empty response');
    return data as T;
  } catch {
    throw new Error('Invalid JSON response from server');
  }
}
